import { Box, Button, Card, CardContent, CardHeader, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, ToggleButton, ToggleButtonGroup, Toolbar, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import fnsFormat from 'date-fns/format';
import fnsParseIso from 'date-fns/parseISO';
import { useEffect, useState } from 'react';
import { MdCancel, MdCheck, MdDelete, MdEdit } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { formatCurrency } from '../../../../../Utils/formatters';
import { ConfirmationDialog } from '../../components/ConfirmationDialog';

interface PaymentResponse {
  status: string;
  id: string
  dueDate: string
  favored: string
  product: string
  operator: string
  amount: number
  sendDate: string
}

const Payments = () => {

  const [data, setData] = useState<{
    payments: PaymentResponse[],
    page: number,
    rowsPerPage: number,
    totalRows: number
  }>({
    page: 1,
    payments: [],
    rowsPerPage: 10,
    totalRows: 0
  });

  const [filters, setFilters] = useState({
    mode: 'me',
  });

  const [selectedPayments, setSelectedPayments] = useState(new Set<string>([]));

  const [dialogOptions, setDialogOptions] = useState({
    isOpen: false,
    message: '',
    ok: (password = '') => { }
  })

  const getPayments = () => {
    const payments = {
      page: 1,
      totalRows: 1,
      payments: [
        { id: crypto.randomUUID(), dueDate: '2025-05-05', favored: 'Kevin Matheus', product: 'p2p', operator: 'Kaue', amount: 120000, sendDate: '2025-05-04', status: 'Esperando Aprovação' },
        { id: crypto.randomUUID(), dueDate: '2025-05-05', favored: 'Kevin Matheus', product: 'p2p', operator: 'Kaue', amount: 120000, sendDate: '2025-05-04', status: 'Esperando Aprovação' },
        { id: crypto.randomUUID(), dueDate: '2025-05-05', favored: 'Kevin Matheus', product: 'p2p', operator: 'Kaue', amount: 120000, sendDate: '2025-05-04', status: 'Esperando Aprovação' },
        { id: crypto.randomUUID(), dueDate: '2025-05-05', favored: 'Kevin Matheus', product: 'p2p', operator: 'Kaue', amount: 120000, sendDate: '2025-05-04', status: 'Esperando Aprovação' },
        { id: crypto.randomUUID(), dueDate: '2025-05-05', favored: 'Kevin Matheus', product: 'p2p', operator: 'Kaue', amount: 120000, sendDate: '2025-05-04', status: 'Esperando Aprovação' },
        { id: crypto.randomUUID(), dueDate: '2025-05-05', favored: 'Kevin Matheus', product: 'p2p', operator: 'Kaue', amount: 120000, sendDate: '2025-05-04', status: 'Esperando Aprovação' },
        { id: crypto.randomUUID(), dueDate: '2025-05-05', favored: 'Kevin Matheus', product: 'p2p', operator: 'Kaue', amount: 120000, sendDate: '2025-05-04', status: 'Esperando Aprovação' },
        { id: crypto.randomUUID(), dueDate: '2025-05-05', favored: 'Kevin Matheus', product: 'p2p', operator: 'Kaue', amount: 120000, sendDate: '2025-05-04', status: 'Esperando Aprovação' },
      ]
    }

    payments.totalRows = payments.payments.length;

    setData(oldData => ({ ...oldData, ...payments }))
  }

  const handlePageChanged = (page: number) => {

  }

  const selectedPayment = (id: string) => {
    const isSelected = selectedPayments.has(id);

    const newSelectedPayments = new Set(selectedPayments);

    if (isSelected) {
      newSelectedPayments.delete(id);
    }
    else {
      newSelectedPayments.add(id);
    }

    setSelectedPayments(newSelectedPayments);
  }

  const selectedAllPayments = () => {
    const isSelectedAll = selectedPayments.size >= data.payments.length;

    const newSelectedPayments = new Set(selectedPayments);

    if (!isSelectedAll) {
      for (const payment of data.payments) newSelectedPayments.add(payment.id);
    }
    else {
      newSelectedPayments.clear();
    }

    setSelectedPayments(newSelectedPayments);
  }

  const approvePayments = async (password: string) => {
    console.log(password);
  }

  const rejectPayments = async (password: string) => {

  }

  useEffect(() => {
    getPayments();
  }, [])

  return (
    <Box>
      <ConfirmationDialog
        isOpen={dialogOptions.isOpen}
        message={dialogOptions.message}
        onClose={() => setDialogOptions(oldDialog => ({ ...oldDialog, isOpen: false }))}
        onSubmit={dialogOptions.ok}
      />
      <Grid component='form' mb={2} container>
        <Grid item xs={12}>
          <ToggleButtonGroup exclusive value={filters.mode} onChange={(_, mode) => setFilters((oldFilters => ({ ...oldFilters, mode })))}>
            <ToggleButton value='me'>Pendentes (Você)</ToggleButton>
            <ToggleButton value='others'>Pendentes (Outros)</ToggleButton>
            <ToggleButton value='all'>Todos</ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>

      <Card sx={{ mb: 2, maxWidth: 500 }} >
        <CardHeader title="Pagamentos" />
        <CardContent>
          <Typography>R$ 200,00</Typography>
        </CardContent>
      </Card>

      <Box mb={2} display='flex' justifyContent='space-between'>
        <Button variant='contained'>
          Filtros
        </Button>

        <Button>Exportar</Button>
      </Box>

      <Paper>
        <Toolbar sx={{ bgcolor: t => t.palette.grey['200'], display: 'flex', justifyContent: 'space-between' }}>
          <Typography>
            {selectedPayments.size} pagamento(s) selecionado(s)
          </Typography>
          {
            selectedPayments.size > 0 && (
              <Box>
                <IconButton
                  title="Aprovar Pagamento"
                  onClick={() => setDialogOptions({
                    isOpen: true,
                    message: 'Você deseja aprovar os pagamentos selecionados?',
                    ok: approvePayments
                  })}
                >
                  <MdCheck />
                </IconButton>
                <IconButton
                  title="Reprovar Pagamento"
                  onClick={() => setDialogOptions({
                    isOpen: true,
                    message: 'Você deseja reprovar os pagamentos selecionados?',
                    ok: rejectPayments
                  })}
                >
                  <MdCancel />
                </IconButton>
                <IconButton
                  title="Excluir todos os selecionados"
                  onClick={() => setSelectedPayments(new Set([]))}
                >
                  <MdDelete />
                </IconButton>
              </Box>
            )
          }
        </Toolbar>
        <TableContainer sx={{ maxHeight: 600 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell padding='checkbox'>
                  <Checkbox
                    onChange={e => selectedAllPayments()}
                    indeterminate={selectedPayments.size > 0 && selectedPayments.size < data.payments.length}
                    checked={selectedPayments.size === data.payments.length}
                  />
                </TableCell>
                <TableCell>Ações</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Vencimento</TableCell>
                <TableCell>Favorecido</TableCell>
                <TableCell>Produto</TableCell>
                <TableCell>Operador</TableCell>
                <TableCell>Valor</TableCell>
                <TableCell>Envio</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                data.payments.map(payment => {
                  const isSelected = selectedPayments.has(payment.id)
                  return (
                    <TableRow sx={{ bgcolor: isSelected ? t => t.palette.grey[100] : undefined }} key={payment.id}>
                      <TableCell padding='checkbox'>
                        <Checkbox
                          checked={isSelected}
                          onChange={() => selectedPayment(payment.id)}
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton component={Link} to={'/pay-office/' + payment.id}>
                          <MdEdit />
                        </IconButton>
                      </TableCell>
                      <TableCell>{payment.status}</TableCell>
                      <TableCell>{fnsFormat(fnsParseIso(payment.dueDate), 'dd/MM/yyyy')}</TableCell>
                      <TableCell>{payment.favored}</TableCell>
                      <TableCell>{payment.product}</TableCell>
                      <TableCell>{payment.operator}</TableCell>
                      <TableCell>{formatCurrency(payment.amount)}</TableCell>
                      <TableCell>{fnsFormat(fnsParseIso(payment.sendDate), 'dd/MM/yyyy HH:mm')}</TableCell>
                    </TableRow>
                  )
                })
              }
              {
                data.payments.length === 0 && (
                  <TableRow>
                    <TableCell align='center' colSpan={999}>Não há pagamentos para serem exibidos</TableCell>
                  </TableRow>
                )
              }
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          count={data.totalRows}
          page={data.page - 1}
          rowsPerPage={data.rowsPerPage}
          onPageChange={(e, page) => handlePageChanged(page)}
        />
      </Paper>
    </Box>
  )
}

export { Payments };

